export default __webpack_public_path__ + "static/media/youtube.daa353e9.svg";